<template>
  <div
    v-if="isHelpDetail"
    class="card-item relative helpDetail"
    :class="isChinese() ? 'h-[204px]' : 'h-[222px]'"
  >
    <nuxt-link :to="urls" class="flex flex-col items-center">
      <Resource
        :src="item.cover_url"
        :transform-resource="transformImage"
        class="mb-[20px]"
        :class="isChinese() ? 'w-[36px] h-[36px]' : 'w-[54px] h-[54px]'"
      />
      <div
        class="truncate font-[600] text-font-1 mb-[12px] title max-w-[370px]"
        :class="isChinese() ? 'text-[16px] leading-[24px]' : 'text-[18px] leading-[30px]'"
      >
        <span class="truncate">{{ item.title }}</span>
      </div>
      <div
        class="text-[var(--text-1-60)] truncate text-[14px] mb-[16px] leading-[16px] font-400 mb-[20px]"
        :class="isChinese() ? '' : 'max-w-[370px]'"
      >
        {{ item.subtitle }}
      </div>
      <div
        class="text-[var(--text-1-40)] absolute leading-[20px] text-[12px] bottom-[20px] left-[50%] transform -translate-x-1/2"
      >
        {{ $t('gong-itemdocumentslength-pian-wen-zhang', [item.online_document_number]) }}
      </div>
      <XTag
        v-if="item.is_new"
        type="new"
        size="large"
        class="absolute top-[12px] left-[12px]"
      ></XTag>
    </nuxt-link>
  </div>
  <div v-else class="card-item-cover">
    <nuxt-link :to="urls">
      <Resource
        :src="item.cover_url"
        :transform-resource="transformImage"
        class="w-full h-full absolute left-0 top-0 z-0"
      />
      <div class="relative z-1">
        <div class="flex-y-center gap-[5px]">
          <div class="truncate text-[20px] font-semibold text-[var(--help-text-color)]">
            <span class="truncate">{{ item.title }} </span>
          </div>
          <XTag v-if="item.is_new" type="new" />
        </div>
        <div class="text-[var(--help-text-color)] text-14 mt-[20px] leading-[24px] font-semibold">
          {{ item.description }}
        </div>
        <div class="mt-[30px]">
          <a-button class="btns font-semibold">
            {{ $t('li-ji-cha-kan') }}
          </a-button>
        </div>
      </div>
    </nuxt-link>
  </div>
</template>

<script lang="ts" setup>
import type { IHelpCategory } from '~/api/index';
import { PageKey } from '~/constants/page';
import { transformImage } from '~/utils/';
import XTag from '@/components/xTag/index.vue';
import { isChinese } from '~/utils/area';

const { $t } = useNuxtApp();

const props = defineProps<{
  item: IHelpCategory;
}>();

const isHelpDetail = computed(() => !props.item.jump_url);

const urls = computed(() => {
  if (props.item?.jump_url) {
    return { path: props.item.jump_url };
  }
  if (isHelpDetail.value) {
    return {
      name: PageKey.HELP_CENTER_DETAIL,
      params: {
        id: `${props.item.id}${props.item.documents.length ? `-${props.item.documents[0].id}` : ''}`,
      },
    };
  }
  if (props.item.id) {
    return {
      name: PageKey.HELP_CENTER_DETAIL,
      params: {
        id: props.item.id,
      },
    };
  }
  return undefined;
});
</script>

<style lang="scss" scoped>
.card-item {
  @apply p-[32px] w-full rounded-[12px] overflow-hidden cursor-pointer;
  &:hover {
    border: 1px solid var(--purple-6);
  }
  border: 1px solid var(--back-5);
  .divider-line {
    border-top: 1px solid var(--back-5);
  }
  .list {
    .item {
      @apply text-[var(--text-1-80)] text-14 mt-[16px] relative pl-[16px] truncate;
      font-weight: 400;
      &:before {
        @apply rounded-full absolute left-[0px] top-[50%] transform translate-y-[-50%];
        content: '';
        height: 4px;
        width: 4px;
        background: var(--text-1-80);
      }
      &:hover {
        @apply text-primary;
        &:before {
          background: var(--purple-6);
        }
      }
    }
  }
}
.card-item-cover {
  @apply w-full h-[232px] p-[33px_29px] rounded-[12px] overflow-hidden cursor-pointer relative;
  .btns {
    @apply rounded-[18px] text-[14px] min-w-[120px] h-[36px];
    border-color: var(--help-text-color);
    color: var(--help-text-color);
    background: transparent;
  }
}
.font-400 {
  font-weight: 400;
}
</style>
